var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_c('amenity-manatee-loading')],1):_c('div',[_c('td',[_vm._v(_vm._s(this.billingRampPeriod.SequenceNumber))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.billingRampPeriod.Percentage)+"%")])])])}
var staticRenderFns = []

export { render, staticRenderFns }